import PropTypes from 'prop-types';

export const PropTypesFormApi = PropTypes.shape({
  touched: PropTypes.object,
});

export const PropTypesFieldApi = PropTypes.shape({
  fieldName: PropTypes.string,
});
